import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServerService {

  constructor(private http:HttpClient) { }
  
  header:HttpHeaders=new HttpHeaders(
    {
      "content-type": "application/json",
    }
  );

  url="http://13.127.227.136:8000";
  bookurladdon="/api/book/";
  registerurladdon="/api/register/";
  body="";

  
  async book(data:string){
    this.body=data;
    await this.http.post(this.url+this.bookurladdon,this.body,{headers: this.header}).toPromise().then((data:any)=>{
      alert("Booked successfully");
    }).catch((errormsg:any)=>{
      alert(errormsg.error.error_message.email[0]);
    });
  }

  async register(data:string){
    this.body=data;
    await this.http.post(this.url+this.registerurladdon,this.body,{headers: this.header}).toPromise().then((data:any)=>{
      alert("Registered successfully");
    }).catch((errormsg:any)=>{
      alert(errormsg.error.error_message.email[0]);
    });
  }


  test(){
    this.http.post(this.url,"test api").toPromise().then((data:any)=>{console.log(data)});
  }
}
